import { Component, EventEmitter, input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { provideTranslocoScope, type Translation, TranslocoModule } from '@jsverse/transloco';
import type { FooterMeta } from './FooterMeta';

export const loader = ['en', 'de'].reduce((acc: { [x: string]: () => Promise<Translation> }, lang) => {
  acc[lang] = () => import(`./i18n/${lang}.json`);
  return acc;
}, {});
@Component({
  selector: 'dtis-footer',
  imports: [MatIconModule, TranslocoModule, RouterModule],
  templateUrl: './footer.component.html',
  providers: [provideTranslocoScope({ scope: 'footer', loader })],
})
export class DtisFooterComponent {
  /**
   *
   */
  displayFooterLogo = input(false);
  /**
   * To display of the right of the footer
   */
  appVersion = input.required<string>();
  /**
   *
   */
  metadata = input<FooterMeta[]>([]);
  /**
   * Observable indicating if the current user has admin privileges.
   * This defaults to a function returning false to ensure compatibility.
   */
  isAdmin$ = input<() => boolean>(() => false);
  /**
   *
   */
  @Output() toggleDebug = new EventEmitter();
  /**
   *
   */
  footerLinks: { link: string; title: string; external: boolean }[] = [];
}
